import axios from 'axios';

export const PERFORM_REQUEST = 'PERFORM_REQUEST';
export const PERFORM_REQUEST_PAST = 'PERFORM_REQUEST_PAST';
export const PERFORM_REQUEST_SUCCESS =
  'PERFORM_REQUEST_SUCCESS';
export const PERFORM_REQUEST_FAILURE =
  'PERFORM_REQUEST_FAILURE';
export const SET_PAGE = 'SET_PAGE';

export function performRequest() {
    return (dispatch, getState) => {
        dispatch({ type: PERFORM_REQUEST });
      return axios
            .get('/api/v1/events/getevents/',{
            params: {
                lang: getState().language,
                page: getState().page,
                size: getState().size,
                },
              })
        .then(response => {
            dispatch({
              type: PERFORM_REQUEST_SUCCESS,
              data: response.data,
            });
          })
          .catch(error => {
            console.error('PERFORM_REQUEST_FAILURE', error);
            dispatch({ type: PERFORM_REQUEST_FAILURE });
          });
  };
}


export function setPage(page) {
  return {
    type: SET_PAGE,
    page,
  };
}



